<script lang="ts" setup>
import { StatusMessage, Button } from "@/shared/components";

defineProps<{
  title: string;
  text?: string;
}>();
</script>

<template>
  <div class="status-message-page">
    <div class="status-message-page--content">
      <StatusMessage :title="title">
        <template #text>
          <p v-if="text">{{ text }}</p>
          <slot name="text"></slot>
        </template>
        <template #actions>
          <Button
            :caption="$t('shared.action.toLogin')"
            href="/DigitalServicesLogin"
          />
        </template>
      </StatusMessage>
    </div>
  </div>
</template>

<style scoped>
@import "StatusMessagePage.css";
</style>
